export function navigateToUrl(url="",replace){if(url){history[replace?"replaceState":"pushState"](history.state,"",url)}}export default navigateToUrl;